import React, { useEffect } from "react";

export default function LoadAudioList({ mediaPath, srcList, onEnded, audioRef }) {
    useEffect(() => {
        return () => {
            // cleanup: 모든 오디오 src 비우고 unload
            audioRef.forEach((ref) => {
                if (ref.current) {
                ref.current.pause();
                ref.current.removeAttribute("src");
                ref.current.load();
                }
            });
        };
    }, [audioRef]);

    if (!srcList || srcList.length < 1) return null;

    srcList.forEach(() => {
        audioRef.push(React.createRef());
    });

    return (
        <>
            {srcList.map((item, index) => (
                <audio
                    playsinline
                    webkit-playsinline
                    key={index}
                    preload="none"
                    ref={audioRef[index]}
                    src={(item.audio ? mediaPath + item.audio + "?v=" + Math.random() : '')}
                    onEnded={onEnded}
                />
            ))}
        </>
    );
};